// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"b7a15a21","453":"7b5a472c","455":"300b44d2","470":"75871124","713":"86fc02d9","738":"ac23b181","800":"bf1b0df5"}[chunkId] + ".chunk.js";
};